import type { SlideProps } from "@/engine/app/offsite-config";

const STEPS = [
  "Kunde meldet Zählerstand online",
  "System validiert Eingabe",
  "Make.com nimmt den Vorgang auf",
  "kVASy prüft Plausibilität",
  "Validierter Zählerstand wird gesetzt",
  "Bestätigung geht an den Kunden",
  "Vorgang wird dokumentiert",
];

const SAFETY_NET = [
  {
    title: "Validierungs-Rückfrage",
    text: "Schlägt ein Schritt fehl, fehlt eine Info oder ist sie unplausibel, bekommt der Kunde automatisch eine Rückfrage zur Validierung.",
  },
  { title: "Rückmeldung", text: "Der Kunde bekommt immer eine klare Antwort." },
  {
    title: "Ticket bei euch",
    text: "Wenn etwas unklar bleibt, landet der Fall bei euch – nicht im Nirwana.",
  },
];

export function Slide14HinterDenKulissen(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Hinter den Kulissen</div>
        <h1 className="deck-title rise rise-2">
          Was passiert, wenn ein Kunde <br />
          <span className="accent">seinen Zählerstand online meldet?</span>
        </h1>
      </header>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1.4fr 1fr",
          gap: 28,
          alignItems: "start",
        }}
      >
        <div className="process-list rise rise-4">
          {STEPS.map((s, i) => (
            <div
              key={s}
              className={`process-step${i === STEPS.length - 1 ? " is-final" : ""}`}
            >
              <div className="num">{i + 1}</div>
              <div className="label">{s}</div>
            </div>
          ))}
        </div>

        <div
          className="col-card rise rise-5"
          style={{ alignSelf: "start", position: "sticky", top: 32 }}
        >
          <div className="col-eyebrow" style={{ color: "var(--svo-blau)" }}>
            Sicherheitsnetz
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            {SAFETY_NET.map((item) => (
              <div key={item.title}>
                <h4 style={{ marginBottom: 4 }}>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
